
export const bgUserRole = (value) => {
    value = (value ? value.toString().toLowerCase() : '');

    switch (value) {
        case "superadmin":
            return "primary";
            break;
        case "admin":
            return "info";
            break;
        case "staff":
            return "secondary";
            break;
        default:
            return 'default';
            break;
    }
}

export const bgInvoiceStatus = (value) => {
    value = (value ? value.toString().toLowerCase() : '');
    
    switch (value) {
        case "inprogress":
            return "primary";
            break;
        case "completed":
            return "success";
            break;
        default:
            return 'default';
            break;
    }
}

export const bgPaymentStatus = (value) => {
    value = (value ? value.toString().toLowerCase() : '');

    switch (value) {
        case "unpaid":
            return "danger";
            break;        
        case "paid":
            return "success";
            break;
        case "partly paid":
            return "warning";
            break;
        default:
            return 'default';
            break;
    }
}
